export const FETCH_COMPACT_SITE_REQUEST = '@siteCompact/FETCH_COMPACT_SITE_REQUEST';
export const FETCH_COMPACT_SITE_SUCCESS = '@siteCompact/FETCH_COMPACT_SITE_SUCCESS';
export const FETCH_COMPACT_SITE_FAILURE = '@siteCompact/FETCH_COMPACT_SITE_FAILURE';

export const FETCH_COMPACT_SITE_PAGINATE_REQUEST = '@siteCompactPaginate/FETCH_COMPACT_SITE_PAGINATE_REQUEST';
export const FETCH_COMPACT_SITE_PAGINATE_SUCCESS = '@siteCompactPaginate/FETCH_COMPACT_SITE_PAGINATE_SUCCESS';
export const FETCH_COMPACT_SITE_PAGINATE_FAILURE = '@siteCompactPaginate/FETCH_COMPACT_SITE_PAGINATE_FAILURE';
